// @ts-expect-error
import CharPickerData from 'char-picker-data';
import React from 'react';

import CharPreview from 'notebook/mediocre/symbols/CharPreview';
import getTestProps from 'test/lib/cypress/getTestProps';

import isCharBlocked from './isCharBlocked';

export const COMMON_SYMBOLS = [
  '\u00B0', // DEGREE
  '\u2020',
  '\u2021', // DAGGER and DOUBLE DAGGER
  // ALPHA to OMEGA (lowercase)
  '\u03B1',
  '\u03B2',
  '\u03B3',
  '\u03B4',
  '\u03B5',
  '\u03B6',
  '\u03B7',
  '\u03B8',
  '\u03B9',
  '\u03BA',
  '\u03BB',
  '\u03BC',
  '\u03BD',
  '\u03BE',
  '\u03BF',
  '\u03C0',
  '\u03C1',
  '\u03C3',
  '\u03C4',
  '\u03C5',
  '\u03C6',
  '\u03C7',
  '\u03C8',
  '\u03C9',
  // ALPHA to OMEGA (uppercase)
  '\u0391',
  '\u0392',
  '\u0393',
  '\u0394',
  '\u0395',
  '\u0396',
  '\u0397',
  '\u0398',
  '\u0399',
  '\u039A',
  '\u039B',
  '\u039C',
  '\u039D',
  '\u039E',
  '\u039F',
  '\u03A0',
  '\u03A1',
  '\u03A3',
  '\u03A4',
  '\u03A5',
  '\u03A6',
  '\u03A7',
  '\u03A8',
  '\u03A9',
];

interface CharListingProps {
  charPickerData: CharPickerData;
  searchQuery: string;
  searchResults: Array<string>;
  category: number;
  subCategory: number;
  selectChar: (args: {char: string; insert: boolean}) => void;
}

class CharListing extends React.PureComponent<CharListingProps> {
  static COMMON_SYMBOLS_SUBCATEGORY = -1;

  getChars(): Array<string> {
    if (this.props.searchQuery.length) {
      return this.props.searchResults;
    }
    if (this.props.subCategory === CharListing.COMMON_SYMBOLS_SUBCATEGORY) {
      return COMMON_SYMBOLS;
    }
    const subCategoryChars = this.props.charPickerData.charList[this.props.category][this.props.subCategory];
    return CharPickerData.helpers.toCharList(subCategoryChars);
  }

  override render(): JSX.Element {
    return (
      <div
        className="charListing u-small-spacing-top"
        {...getTestProps({component: 'CharListing', element: 'root'})}
      >
        {Array.from(this.getChars())
          .filter((char) => !isCharBlocked(char))
          .map((char, i) => (
            <CharPreview key={i} char={char} selectChar={this.props.selectChar} />
          ))}
      </div>
    );
  }
}

export default CharListing;
